import Profile from '../views/Profile';
import ProfileIndex from '../views/profile/Index';
import ProfileSuccess from '../views/profile/Success';

export const PROFILE_ROUTES = {
    path: '/profile',
    component: Profile,
    meta: { title: 'Profile' },
    children: [
        {
            path: '',
            name: 'profile',
            component: ProfileIndex,
            meta: { title: 'Update Profile' }
        },
        {
            path: 'success',
            name: 'profile-success',
            component: ProfileSuccess,
            meta: { title: 'Profile' }
        }
    ]
};
